exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".description[data-v-4fac53ce]{font-size:.9em}", ""]);

// exports
